/**
 * @generated SignedSource<<04a21f6e49f1e06044893af228afb1ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RetryReportWithIntegrationInput = {
  integrationId: string;
  reportId: string;
};
export type useRetryReportWithIntegrationMutation$variables = {
  input: RetryReportWithIntegrationInput;
};
export type useRetryReportWithIntegrationMutation$data = {
  readonly retryReportWithIntegration: {
    readonly success: boolean | null;
  } | null;
};
export type useRetryReportWithIntegrationMutation = {
  variables: useRetryReportWithIntegrationMutation$variables;
  response: useRetryReportWithIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RetryReportWithIntegrationPayload",
    "kind": "LinkedField",
    "name": "retryReportWithIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRetryReportWithIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRetryReportWithIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "95faec969cacdc4ed41f1a83c1cbb56f",
    "id": null,
    "metadata": {},
    "name": "useRetryReportWithIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation useRetryReportWithIntegrationMutation(\n  $input: RetryReportWithIntegrationInput!\n) {\n  retryReportWithIntegration(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "63973895250688d06e4d7488fa3701aa";

export default node;
